import React, { forwardRef } from 'react';
import styled from 'styled-components';
var SliderRange = styled.input.withConfig({
  displayName: "Slider__SliderRange",
  componentId: "sc-1b5n2h3-0"
})(["appearance:none;width:100%;height:4px;background-color:", ";border-radius:16px;outline:none;&::-webkit-slider-thumb{appearance:none;width:24px;height:24px;background:", ";border:4px solid ", ";box-shadow:0px 1px 10px rgba(0,0,0,0.12);border-radius:50%;cursor:pointer;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey.light;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary.base;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.base.white;
});
export var Slider = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var id = _ref4.id,
      min = _ref4.min,
      max = _ref4.max,
      value = _ref4.value,
      _onChange = _ref4.onChange,
      defaultValue = _ref4.defaultValue;
  return /*#__PURE__*/React.createElement(SliderRange, {
    ref: ref,
    type: "range",
    min: min,
    max: max,
    value: value,
    defaultValue: defaultValue,
    id: id,
    onChange: function onChange(e) {
      return _onChange(e.target.value, e);
    }
  });
});